import { Radio, RadioGroupProps, Select, SelectProps } from 'antd'

import { useLocales } from 'src/locales'

import { ReadOnlyChoice, useIsReadOnlyForm } from '../ReadOnly'

type Props = {
  values: string[]
  /** Translation key prefix; the label of a value is `${labelPrefix}.${value}`. */
  labelPrefix: string
}

/** A fixed list of the form (an API enum) as radio buttons. */
export const EnumRadio = ({
  values,
  labelPrefix,
  ...props
}: Props & RadioGroupProps) => {
  const { t } = useLocales()
  const isReadOnly = useIsReadOnlyForm()

  if (isReadOnly) {
    return (
      <ReadOnlyChoice
        label={props.value ? t(`${labelPrefix}.${props.value}`) : undefined}
      />
    )
  }

  return (
    <Radio.Group {...props}>
      {values.map((value) => (
        <Radio key={value} value={value}>
          {t(`${labelPrefix}.${value}`)}
        </Radio>
      ))}
    </Radio.Group>
  )
}

/** A fixed list of the form (an API enum) as a select, for longer lists. */
export const EnumSelect = ({
  values,
  labelPrefix,
  ...props
}: Props & SelectProps<string>) => {
  const { t } = useLocales()

  return (
    <Select
      allowClear
      placeholder={t('common.select_from_list')}
      options={values.map((value) => ({
        value,
        label: t(`${labelPrefix}.${value}`)
      }))}
      {...props}
    />
  )
}
